import applicationSurvey from "./applicationSurvey";
import applicationSurveyWithAnswer from "./applicationSurveyWithAnswer";

const applicationSurveyService = [
    {
        matcher: /questionnaire\/(.*)/,
        reply: config => {
            const id = /questionnaire\/(.*)/.exec(config.url)[1];
            return [200, applicationSurvey];
        }
    },
    {
        matcher: 'questionnaireWithAnswer',
        reply: config => {
            return [200, applicationSurveyWithAnswer];
        }
    },
]

export default applicationSurveyService;